import Axios from '../../utils/tms-axios/tms-axios';

export const subTempleService = {
  getAllSubTemples: async (templeId, page = 1, limit = 10) => {
    const resp = await Axios.get(`/v1/sub-temple/get-all`, {
      params: {
        page: page,
        limit: limit,
      },
      headers: {
        'X-Temple-Id': templeId,
      },
    });

    return resp.data;
  },

  createSubTemple: async (templeId, shortName, name) => {
    console.log('templeId', templeId, 'shortName', shortName, 'name', name);
    const resp = await Axios.post(
      `/v1/sub-temple/create`,
      {
        shortName: shortName,
        name: name,
      },
      {
        headers: {
          'X-Temple-Id': templeId,
        },
      }
    );

    return resp.data;
  },

  updateSubTemple: async (templeId, subTempleId, shortName, name) => {
    const resp = await Axios.put(
      `/v1/sub-temple/update/${subTempleId}`,
      {
        shortName: shortName,
        name: name,
      },
      {
        headers: {
          'X-Temple-Id': templeId,
        },
      }
    );

    return resp.data;
  },

  deleteSubTemple: async (templeId, subTempleId) => {
    const resp = await Axios.delete(`/v1/sub-temple/delete/${subTempleId}`, {
      headers: {
        'X-Temple-Id': templeId,
      },
    });

    return resp.data;
  },
};
